<template>
 <div id="revenuechart"></div>  
</template>

<script>
import { statisticsService } from "../../../shared/services";
import ApexCharts from 'apexcharts'
export default {
  props: {
      date: null,
  },
  async mounted() {
    if(this.date == null) return;
    await this.MonthlyRevenue();
  },  
  methods: {
    async MonthlyRevenue() {
      var revenueCurrentMonth = null;
      var revenueLastMonth = null;
      var revenueLastYearMonth = null;
      try {
        const revenueCurrentMonthCall = statisticsService.getRevenue(this.$moment(this.date).year(), this.$moment(this.date).month() + 1);
        const revenueLastMonthCall = statisticsService.getRevenue(this.$moment(this.date).subtract(1, 'months').year(), this.$moment(this.date).subtract(1, 'months').month() + 1);
        const revenueLastYearMonthCall = statisticsService.getRevenue(this.$moment(this.date).subtract(1, 'years').year(), this.$moment(this.date).subtract(1, 'years').month() + 1);

        const [revenueCurrentMonthResult, revenueLastMonthResult, revenueLastYearMonthResult] = await Promise.all([revenueCurrentMonthCall, revenueLastMonthCall, revenueLastYearMonthCall]);

        this.revenueCurrentMonth = revenueCurrentMonthResult;
        this.revenueLastMonth = revenueLastMonthResult;
        this.revenueLastYearMonth = revenueLastYearMonthResult;
        
        
        } catch {
        this.ShowToast("Fel", "Ett okänt fel uppstod när statistik skulle läsas", "danger");
      }

      const dayLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];
      const monthLabels = ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"];

      var options = {
        chart: {
          type: 'line',
          stacked: false,
          height: 350,
          toolbar: {
            show: false,
          },
        },
        fill: {
          opacity: [0.25, 1, 1],
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: "vertical",
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100]
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (y) {
              if (typeof y !== "undefined") {
                return y.toFixed(0) + " kr";
              }
              return y;
        
            }
          }
        },
        stroke: {
          width: [2, 3, 3],
          curve: 'smooth',
        },  
        series: [{
          name: `${monthLabels[this.$moment(this.date).month()]} ${this.$moment(this.date).year()}`,
          type: 'area',
          data: this.revenueCurrentMonth
        }, {
          name: `${monthLabels[this.$moment(this.date).subtract(1, 'months').month()]} ${this.$moment(this.date).subtract(1, 'months').year()}`,
          type: 'line',
          data: this.revenueLastMonth
        },{
          name: `${monthLabels[this.$moment(this.date).subtract(1, 'years').month()]} ${this.$moment(this.date).subtract(1, 'years').year()}`,
          type: 'line',
          data: this.revenueLastYearMonth
        },],
        xaxis: {
          categories: this.dayLabels
        },
        colors: ['#5499C7', '#CD6155', '#58D68D', '#F5B041', '#D4EFDF', '#F2D7D5'],
      }

      var chart = new ApexCharts(document.querySelector("#revenuechart"), options);
      chart.render();  
    }
  }
};
</script>